import "./AvailableEventTile.css";

import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router";

import { ArrowBadge } from "~/components/Home/Dashboard/shared/ArrowBadge/ArrowBadge";
import Assignment from "~/content/icons/assignment.svg?react";
import { toPrettyLocaleDateString } from "~/helpers/date-helpers";
import { formatDurationToNow } from "~/helpers/relative-time-helpers";

export function AvailableEventTile({ event, now }) {
  const { t } = useTranslation();

  const duration = formatDurationToNow(event.scheduledEndDateTime, now);
  const remainingLabel = duration
    ? t("home.event.remaining", { duration })
    : null;

  const targetDate = toPrettyLocaleDateString(event.target, {
    weekday: "long",
    month: "long",
    day: "numeric",
  });

  return (
    <RouterLink
      className="available-event-tile"
      data-testid="available-event-tile"
      to={`/events/${event.formId}/form/1`}
    >
      <div className="available-event-tile__header">
        <div className="available-event-tile__heading">
          <h2 className="available-event-tile__form-name">{event.formName}</h2>
          <p className="available-event-tile__target-date">
            {t("home.event.for_date", { date: targetDate })}
          </p>
        </div>
        <ArrowBadge className="available-event-tile__arrow" color="green" />
      </div>
      {remainingLabel && (
        <div className="available-event-tile__footer">
          <Assignment
            aria-hidden="true"
            className="available-event-tile__icon"
          />
          <p className="available-event-tile__remaining">{remainingLabel}</p>
        </div>
      )}
    </RouterLink>
  );
}

AvailableEventTile.propTypes = {
  event: PropTypes.shape({
    formId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    formName: PropTypes.string.isRequired,
    target: PropTypes.string,
    scheduledEndDateTime: PropTypes.string,
  }).isRequired,
  now: PropTypes.string,
};
